<div class="app-view">
  <div class="app-container">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>